import { Module } from "@/modules/tenantAdmin/enums";

export default [
  {
    path: "/onboarding",
    meta: {
      module: Module.Onboarding,
    },
    children: [
      {
        path: "",
        name: "onboarding.welcome",
        component: () =>
          import("@/modules/tenantAdmin/onboarding/views/OnboardingWelcomeView.vue"),
      },
      {
        path: "steps",
        name: "onboarding.tool",
        component: () =>
          import("@/modules/tenantAdmin/onboarding/views/OnboardingFlowView.vue"),
      },
    ],
  },
];
